/** Виконує async fn, логує помилку, не пробрасывает далі (щоб не блокувати інші кроки). */
export async function runSafe(
  fn: () => Promise<void>,
  logLabel: string
): Promise<void> {
  try {
    await fn()
  } catch (err) {
    console.error(`${logLabel}:`, err)
  }
}
